export function Brand({ name, onClick, light = false }: { name: string; onClick?: () => void; light?: boolean }) {
  return <button className={`brand ${light ? 'brand-light' : ''}`} onClick={onClick} aria-label={`${name} home`}>
    <span>{name}<span className="brand-period">.</span></span>
  </button>;
}
